var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "url(#pattern0_133_1048)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_133_1048",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_133_1048",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_133_1048",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAZ5JREFUSEvtlTtLw1AYht8vSemdZnSoUHH01lZwEaSoOCheEFwcHf0F/gT/gZvg5OTkFSepg7ik1oLoPxBFDdJmsJpPTmlCmhbq6WUza5Lneb/3nJwQ+nxRn/noqeCjEEoR1ANVoY34RPlFhG8QmEbkHoQxiamqZNNKYrJyUYOzkgdhEKBDPVPZbBYUIiwB/yKbVl04lGsASTBKFNRyiZHP924ELvytGE6qNt3U4MSPFAhMO/BOBX64SJ4ScNVWZ+LZ8qu3hcY1aF9RlYC1RMY6qyfPAxhi4EFjJSfg5l10QU9XLh2JjKBtcrMYmwXbp3raCssKvsmmZbGg9eRNtThwMEJ6xnKD/20Cxraetfbq8CsAw97OTSM6D+ITAEGRXFpAjMVE1jo3jcgRCOsAP2lVJRebqjybRnQOxMcA3Fq6EIR3QTSuVWmrBhed27ZI7sI7mwBYEjvHu/28nfs/TukJQLTDTLcOSOGfASba9yd37ssLJM6PjiqS5Mvvon+B24BZiJQAjMpW4nu+oGesbMuzqEtwy9d7+k9uZei74BeE9egZXzbnDwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.355c19aed0e7074ee63e80dd60f069ef.svg";
export { ForwardRef as ReactComponent };